<template>
  <template v-if="isLoggedInStatusReady">
    <slot fadeClass="help-center-external-links__fade" />

    <HelpCenterExternalLink
      v-for="externalLink in filteredLinks"
      :key="externalLink.id"
      class="help-center-external-links__fade"
      :external-link="externalLink"
    />
  </template>
</template>

<script setup>
import { computed } from 'vue'
import useHelpCenterVisitor from 'help-center/composables/useHelpCenterVisitor'
import HelpCenterExternalLink from 'help-center/components/HelpCenterExternalLink'

const props = defineProps({
  externalLinks: {
    type: Array,
    required: true
  }
})

const filteredLinks = computed(() => {
  return props.externalLinks.filter((link) => {
    return link.when_logged_in === isLoggedIn.value
  })
})

const { isLoggedIn, isLoggedInStatusReady } = useHelpCenterVisitor()
</script>

<style lang="scss">
@import 'help-center/mixins';

.help-center-external-links {
  &__fade {
    @include help-center-fade-in;
  }
}
</style>
